import EmailSystemManagement from '.'
import { checkProdSite } from '../../helpers/checkProdSite'
import { PageRoute } from '../../routes/routerInterface'

const EmailSystemManagementRoutes: PageRoute[] = [
  {
    path: '/email-system',
    element: EmailSystemManagement,
    isProtected: true,
    permission: checkProdSite(true, 'Admin'),
  },
]

export default EmailSystemManagementRoutes
